import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { environment } from 'src/environments/environment';

// Não autenticado: login com o token da licença na URL quando recuperável;
// senão, tela de informar o token. Abrir página não dispara refresh.
function destinoNaoAutenticado(): UrlTree {
  const chave = inject(AuthenticationService).obterEmpresa?.token_acesso;
  return inject(Router).createUrlTree(chave ? ['/', chave] : ['/']);
}

export const usuarioAutenticadoGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  if (inject(AuthenticationService).canActivate()) return true;

  console.log('nao autenticado, voltando login')
  return destinoNaoAutenticado();
};

// Caminho inválido: autenticado vai ao dashboard; não autenticado, ao login.
export const caminhoInvalidoGuard: CanActivateFn = () => {
  return inject(AuthenticationService).canActivate()
    ? inject(Router).parseUrl(environment.router.dashboard)
    : destinoNaoAutenticado();
};
